import React from 'react'
import classes from './CoreLayout.css'
import 'styles/core.css'
import PropTypes from 'prop-types'

export const CoreLayout = ({ children }) => (
  <div className="container-fluid">
    <div className={classes.mainContainer}>
      {children}
    </div>
  </div>
)

CoreLayout.propTypes = {
  children: PropTypes.element.isRequired
}

export default CoreLayout



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js